<footer class="footer">
    <div class="container-fluid">
        <div class="text-center">
            &copy; {{test | date: 'yyyy'}} Developed By @<a href="https://www.clouddog.com.br">CloudDog</a>
        </div>
    </div>
</footer>
